import type { RouteRecordRaw } from 'vue-router'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/sales-map',
    name: 'SalesMap',
    component: defaultLayout,
    meta: {
      locale: 'common.menus.salesMap',
      requiresAuth: true,
      icon: 'domain-grey',
      hideChildrenInMenu: true,
      activeMenu: 'SalesMap',
      order: 5,
    },
    children: [
      {
        path: '',
        name: 'SalesMapIndex',
        component: () => import('@/views/sales-map/index.vue'),
        meta: {
          locale: 'common.menus.salesMap',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'SalesMap',
          keepAlive: true,
          isTopMenu: true,
        },
      },
      {
        path: 'industry-detail',
        name: 'IndustryDetail',
        component: () => import('@/views/sales-map/industry-detail.vue'),
        meta: {
          locale: 'common.menus.industryDetail',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'SalesMap',
          isTopMenu: true,
        },
      },
      {
        path: 'customer-detail',
        name: 'SalesMapCustomerDetail',
        component: () => import('@/views/sales-map/customer-detail.vue'),
        meta: {
          locale: 'common.menus.customerDetail',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'SalesMap',
          isTopMenu: true,
        },
      },
      {
        path: 'channel-detail',
        name: 'SalesMapChannelDetail',
        component: () => import('@/views/sales-map/channel-detail.vue'),
        meta: {
          locale: 'common.menus.channelDetail',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'SalesMap',
          isTopMenu: true,
        },
      },
    ],
  },
]

export default routes
